import { render, staticRenderFns } from "./Airbox.vue?vue&type=template&id=412c163c"
import script from "./Airbox.vue?vue&type=script&lang=js"
export * from "./Airbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports